import { updateItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">最新快讯</h2>
          <p className="text-sm text-foreground-600 mt-3">实时追踪全网吃瓜热点，不错过每一个精彩瞬间</p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative border-l-2 border-primary-200/60 pl-6 md:pl-8 space-y-8">
            {updateItems.map((item, i) => (
              <div key={i} className="relative group">
                <div className="absolute -left-[calc(1.5rem+5px)] md:-left-[calc(2rem+5px)] top-1 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
                <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
                  <div className="flex items-center gap-2 flex-shrink-0">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.time}</span>
                    <span
                      className={`inline-block px-2 py-0.5 rounded text-[10px] font-bold whitespace-nowrap ${
                        item.tag === '爆'
                          ? 'bg-accent-500 text-background-50'
                          : item.tag === '热'
                            ? 'bg-primary-100 text-primary-700'
                            : 'bg-secondary-100 text-secondary-700'
                      }`}
                    >
                      {item.tag}
                    </span>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-900 leading-snug group-hover:text-primary-500 transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-xs text-foreground-600 mt-1 leading-relaxed">{item.summary}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}